import custom_selector from './custom_selector';

function giftCards() {
  const inputSelector = document?.querySelectorAll('.form-gift');
  const emailSelctor = document?.querySelector('#gift-email');
  const dropdownSelector = document?.querySelector(
    '.dropdown__filter-selected',
  );

  // email validation
  function ValidateEmail(input) {
    const regexEmail =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!input.value.match(regexEmail)) {
      emailSelctor.nextElementSibling.classList.add('active');
      emailSelctor.classList.add('active');
      emailSelctor.previousElementSibling.classList.add('error');
      emailSelctor.nextElementSibling.textContent = 'Invalid Email';
    }
  }

  // Custom Dropdown Event
  function CustomDropdown() {
    const dropdownSelector = '.filter.product-dropdown';
    $(dropdownSelector).on('click', 'li.not-active button', (event) => {
      const currentValue = $(event.currentTarget).attr('value');
      const currentSelector = $(event.currentTarget)
        .closest(dropdownSelector)
        .find('.filter__container');
      const hiddenSelector = $(`#${currentSelector.data('id')}`);

      hiddenSelector.find('option').removeAttr('selected');
      hiddenSelector
        .find(`option[value=${currentValue}]`)
        .attr('selected', true);

      hiddenSelector
        .closest('variant-selects.product__variant-selector-wrapper')
        .get(0)
        .dispatchEvent(new Event('change'), { bubbles: true });
    });
  }

  // Character counter
  function PersonalisedMessage() {
    const personalised_message = $('#personalised_message');

    personalised_message.on('input', (event) => {
      const text_length = $(personalised_message).val().length;
      $(event.currentTarget)
        .siblings('label.form__sub_label')
        .find('.personalised_message__count')
        .text(250 - parseInt(text_length, 10));
    });
  }

  // custom dropdown
  CustomDropdown();

  // text area text counter
  PersonalisedMessage();

  inputSelector.forEach((item) => {
    // input value check
    item.addEventListener('keyup', function () {
      if (item.value) {
        item.previousElementSibling.classList.add('active');
        item.nextElementSibling.classList.remove('active');
        item.previousElementSibling.classList.remove('error');
        item.classList.remove('active');
      } else {
        item.previousElementSibling.classList.remove('active');
      }
    });
    // input validation
    item.addEventListener(
      'invalid',
      (function () {
        return function (e) {
          e.preventDefault();
          inputSelector.forEach((item) => {
            if (!item.value) {
              item.nextElementSibling.classList.add('active');
              item.classList.add('active');
            } else {
              item.nextElementSibling.classList.remove('active');
              item.classList.remove('active');
            }
          });

          ValidateEmail(emailSelctor);
        };
      })(),
      true,
    );
  });

  // gift cards variant dropdown
  custom_selector();

  // prodcut form margin top remove
  document.querySelector('.product-form').style.marginTop = '0px';

  // Tabs function
  const tabs = document.querySelectorAll('[data-tab-target]');
  const tabContents = document.querySelectorAll('[data-tab-content]');

  tabs.forEach((item) => {
    item.addEventListener('click', () => {
      const target = document.querySelector(item.dataset.tabTarget);
      tabContents.forEach((tabContent) => {
        tabContent.classList.remove('active');
      });
      tabs.forEach((item) => {
        item.classList.remove('active');
      });
      item.classList.add('active');
      target.classList.add('active');
    });
  });

  // open and active the first tab
  document.getElementsByClassName('tabs__title')[0]?.classList.add('active');
  document.getElementsByClassName('tab-content')[0]?.classList.add('active');
}

export { giftCards as default };
